/**
 * This is a singleton Obj to store data returned from response.
 * The data should be Set once on initial API response and READ ONLY henceforth
 *  Moving the Read only data to reducers will bloat the Redux store
 * */

class FlySearchResponseModel {
  constructor() {
    this.airports = {}
    this.airlines = {}
    this.filterDefaults = {}
    this.searchSessionKey = ''
    this.clientSessionId = ''
    this.exdCarriers = []
    this.filters = {}
    this.filterableSliceData = {}
    this.priceGuidance = {}
  }
}

const flySearchResponseData = new FlySearchResponseModel()

export { flySearchResponseData }
